export default __webpack_public_path__ + "static/media/secure.246c41bc.svg";